// Availability Status Component - Shows quiz availability status
import React from "react";
import { Quiz } from "../../../types/quiz";

interface AvailabilityStatusProps {
  quiz: Quiz;
  className?: string;
}

const AvailabilityStatus: React.FC<AvailabilityStatusProps> = ({
  quiz,
  className = "",
}) => {
  const getStatusInfo = () => {
    if (quiz.isAvailable) {
      return {
        status: "available",
        color: "bg-green-100 text-green-800 border-green-200",
        icon: "✅",
        text: "Available Now",
      };
    }

    if (quiz.timeUntilStart) {
      return {
        status: "upcoming",
        color: "bg-yellow-100 text-yellow-800 border-yellow-200",
        icon: "⏰",
        text: `Starts ${quiz.timeUntilStart.formatted}`,
      };
    }

    if (quiz.timeUntilEnd && quiz.timeUntilEnd.milliseconds <= 0) {
      return {
        status: "ended",
        color: "bg-red-100 text-red-800 border-red-200",
        icon: "🔒",
        text: "Quiz Ended",
      };
    }

    return {
      status: "not-scheduled",
      color: "bg-gray-100 text-gray-800 border-gray-200",
      icon: "📋",
      text: "Not Scheduled",
    };
  };

  const statusInfo = getStatusInfo();

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <span
        className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border ${statusInfo.color}`}
      >
        <span className="mr-1">{statusInfo.icon}</span>
        {statusInfo.text}
      </span>

      {quiz.timeUntilEnd && quiz.isAvailable && (
        <span className="text-xs text-gray-600">
          Ends {quiz.timeUntilEnd.formatted}
        </span>
      )}
    </div>
  );
};

export default AvailabilityStatus;
